/**
 * SOUND-661 — labelling a stored file category on the client.
 *
 * The vocabulary itself is SERVER-owned (`GET /files/categories`), because
 * FilesTab used to hardcode 8 of the 157 values present in prod — so 1,426 files
 * (41.7%) could not be filtered to and rendered as raw camelCase. Nothing here
 * declares a category; this only turns a value the server sent into text.
 *
 * Lifted out of the JSX because sound-app has no component-test harness, so pure
 * logic is the only part that can be verified without a human clicking.
 */

/**
 * Label for a stored category value.
 *
 * Falls back to the RAW VALUE, never a placeholder or an empty string. An
 * unrecognised category is still the only description of that file anyone has,
 * and blanking it is precisely how 1,426 files became unidentifiable. Only a
 * genuinely absent category gets the placeholder.
 *
 * @param {{value: string, label: string}[]} categories  from GET /files/categories
 * @param {string} value                                 the stored category
 */
export function labelFor(categories, value) {
  if (!value) return "Uncategorised";
  const match = (categories || []).find((c) => c && c.value === value);
  return match?.label || value;
}

/**
 * A category may still carry a fused owner id (`ownerIdUs_<uuid>`) until the
 * SOUND-661 normalisation runs. The SERVER already labels those correctly, so
 * this is only a last-resort tidy for a value that arrived unlabelled — it must
 * never invent a label the server did not send.
 */
export function isFusedCategory(value = "") {
  return /^[A-Za-z]+_[0-9a-fA-F-]{36}$/.test(String(value));
}
